export const Clock = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none">
        <path
            fill="#6E767D"
            fillRule="evenodd"
            d="M6 1.333a4.667 4.667 0 1 0 0 9.334 4.667 4.667 0 0 0 0-9.334ZM.167 6a5.833 5.833 0 1 1 11.666 0A5.833 5.833 0 0 1 .167 6ZM6 2.5c.322 0 .583.261.583.583v2.675l1.58 1.58a.583.583 0 0 1-.826.824l-1.75-1.75A.583.583 0 0 1 5.417 6V3.083c0-.322.26-.583.583-.583Z"
            clipRule="evenodd"
        />
    </svg>
);
